import 'amfe-flexible'
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import { router } from './router'

import VueApexCharts from 'vue-apexcharts'
import { helper } from './helper'

import store from './store/index.js'
import { Tabbar, TabbarItem, Icon, NavBar, Panel, Divider, PullRefresh, Toast, Loading, Tab, Tabs, Skeleton, SwipeCell, Card, Button, ContactCard, ContactList, Locale, Sticky, Grid, GridItem, List, Cell, CellGroup, Field, ActionSheet, Swipe, SwipeItem, AddressEdit, Uploader, Stepper, Form, Popup, Dialog, Picker, Calendar, NumberKeyboard, Notify, Tag, Search, IndexBar, IndexAnchor, AddressList, Collapse, CollapseItem, PasswordInput, Overlay, Empty, Sku, Row, Col, Badge, NoticeBar, Cascader, ImagePreview, Switch, DropdownMenu, DropdownItem } from 'vant';
import VueBarcodeScanner from 'vue-barcode-scanner'

import { Image as VanImage } from 'vant';
Vue.use(VanImage);
let options = {
  sound: true, // default is false
  soundSrc: '/static/sound.wav', // default is blank
  sensitivity: 300, // default is 100
  requiredAttr: true, // default is false
  controlSequenceKeys: ['NumLock', 'Clear'], // default is null
  callbackAfterTimeout: true // default is false
}

Vue.use(VueBarcodeScanner, options);
import Vant from 'vant';
import 'vant/lib/index.css';

Vue.use(Vant);
import trTR from 'vant/lib/locale/lang/tr-TR';
Locale.use('tr-Tr', trTR);

Vue.component('apexchart', VueApexCharts)
Vue.config.productionTip = false
//alert("drg")
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  template: '<App/>',
  components: { App }
})


// WEBPACK FOOTER //
// ./src/main.js